module.exports = __webpack_public_path__ + "img/home-2-features-2-area-bg-effect.ef8f0318.png";